import { render, staticRenderFns } from "./DetailsSelector.vue?vue&type=template&id=874c09cc&scoped=true"
import script from "./DetailsSelector.vue?vue&type=script&lang=ts"
export * from "./DetailsSelector.vue?vue&type=script&lang=ts"
import style0 from "./DetailsSelector.vue?vue&type=style&index=0&id=874c09cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874c09cc",
  null
  
)

export default component.exports